import { useTranslation } from "react-i18next";

import useIsActive from "hooks/useIsActive";

import Button from "components/Button";
import Footer from "components/Footer";
import { Form, FormField } from "components/Form";
import Input from "components/Input";

import useAboutMe from "./useAboutMe";

export default function AboutMe() {
  const { t } = useTranslation();

  useIsActive();

  const { user, form, isDirty, onSubmit, control, handleSubmit } = useAboutMe();

  return (
    <>
      <Form {...form}>
        <form onSubmit={handleSubmit(onSubmit)} id="about-me-form">
          <div className="flex flex-col gap-6 max-w-[670px] w-full mx-auto pb-8 flex-1 overflow-visible">
            <div className="flex flex-col gap-2.5">
              <div>{t("profile.aboutMe.personalDetails")}</div>
              <div className="flex flex-col gap-3.5">
                <FormField
                  control={control}
                  name="firstName"
                  render={({ field }) => (
                    <Input {...field} label={t("profile.aboutMe.firstName")} placeholder={t("profile.aboutMe.firstName")} />
                  )}
                />
                <FormField
                  control={control}
                  name="lastName"
                  render={({ field }) => (
                    <Input {...field} label={t("profile.aboutMe.lastName")} placeholder={t("profile.aboutMe.lastName")} />
                  )}
                />
                <FormField
                  control={control}
                  name="phone"
                  render={({ field }) => (
                    <Input {...field} type="number" label={t("profile.aboutMe.phone")} placeholder={t("profile.aboutMe.phone")} />
                  )}
                />
                <Input
                  value={user?.email ?? ""}
                  label={t("profile.aboutMe.email")}
                  placeholder={t("profile.aboutMe.email")}
                  readOnly
                  disabled
                />
                <FormField
                  control={control}
                  name="residency"
                  render={({ field }) => (
                    <Input {...field} label={t("profile.aboutMe.residency")} placeholder={t("profile.aboutMe.residency")} />
                  )}
                />
              </div>
            </div>
          </div>
        </form>
      </Form>
      <Footer className="md:justify-end">
        <Button disabled={!isDirty} className="w-full md:w-60" type="submit" form="about-me-form" variant="primary">
          {t("button.saveChanges")}
        </Button>
      </Footer>
    </>
  );
}
